const validateDisplayName = (name: string) => {
    const isEmpty = str => !str.trim().length;
    const isTooLong = str => str.trim().length > 50;

    if (isEmpty(name)) {
        return 'Display name cannot be empty';
    } else if (isTooLong(name)) {
        return 'Display name cannot be longer than 50 characters';
    } else {
        return null;
    }
};

export default validateDisplayName;
